/**
 * Builds the tab metadata for the Order Processing Info modal,
 * including initial (loading) and final (data-populated) states.
 * @module createModalMetadata
 */

import React from "react";
import GiScreenshotViewer from "../../../../components/giScreenshotViewer/giScreenshotViewer";
import ProcessesOrderInfoCards from "../../../../components/processedOrderInfoCards/processesOrderInfoCards";
import { ProcessedOrdersData } from "./fetchProcessedOrdersData";

/** Single tab descriptor rendered by the modal. */
export interface ModalTab {
  id: string;
  label: string;
  children: React.ReactNode;
}

/** Shape of the GI data returned by {@link fetchGiData}. */
export interface GiData {
  versions: any;
  total_unique_orders_stored: number;
}

/** Creates placeholder metadata with loading spinners for both tabs. */
export const createInitialModalMetadata = () => {
  return {
    tabs: [
      {
        id: "gi",
        label: "GI",
        children: React.createElement(GiScreenshotViewer, {
          showLoading: true,
        }),
      },
      {
        id: "medical-pa",
        label: "Medical PA",
        children: React.createElement(ProcessesOrderInfoCards, {
          processedOrdersToday: {
            completion_percentage: 0,
            orders_processed: 0,
            orders_remaining: 0,
            time_taken: "",
            loading: false,
            skipped_duplicate_order_ids: [],
          },
          showLoading: true,
        }),
      },
    ],
  };
};

/**
 * Creates final modal metadata with actual data
 * @param giData - GI data containing versions and total unique orders
 * @param processedOrdersData - Processed orders data for today
 * @returns Final modal metadata with actual data
 */
export const createFinalModalMetadata = (
  giData: GiData,
  processedOrdersData: ProcessedOrdersData,
) => {
  return {
    tabs: [
      {
        id: "gi",
        label: "GI",
        children: React.createElement(GiScreenshotViewer, {
          showLoading: false,
          versionsData: giData.versions,
          totalUniqueOrdersStored: giData.total_unique_orders_stored,
        }),
      },
      {
        id: "medical-pa",
        label: "Medical PA",
        children: React.createElement(ProcessesOrderInfoCards, {
          processedOrdersToday: processedOrdersData,
          showLoading: false,
        }),
      },
    ],
  };
};
